var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cutDown"},[_c('div',{staticClass:"time"},[_vm._v(_vm._s(_vm.hour < 0 ? 0 : _vm.hour))]),_c('span',[_vm._v(":")]),_c('div',{staticClass:"time"},[_vm._v(_vm._s(_vm.minute < 0 ? 0 : _vm.minute))]),_c('span',[_vm._v(":")]),_c('div',{staticClass:"time"},[_vm._v(_vm._s(_vm.second < 0 ? 0 : _vm.second))])])
}
var staticRenderFns = []

export { render, staticRenderFns }